import {FC} from 'react';
import {Popup} from 'semantic-ui-react';

import {BaseActionButton} from './BaseActionButton';
import Linker from '../Linker';

import './ManageLinks.less';

class ManageLinks extends BaseActionButton {
  icon = 'linkify';
  tooltip = 'Manage Links';

  visible = () => {
    const {multipleLinks} = this.rackEditorStore;
    return !multipleLinks;
  };

  error = () => {
    const {canManageLinks: {why}, multipleLinks, rackStore} = this.rackEditorStore;
    return (multipleLinks || rackStore.openedLinksGroupId) ? null : why;
  };

  disabled = () => {
    const {multipleLinks, canManageLinks} = this.rackEditorStore;
    return !canManageLinks.result || multipleLinks;
  };

  onClick = () => {
    const {rackStore, selection} = this.rackEditorStore;
    this.hidePopups(false, true);
    rackStore.toggleLinker(undefined, selection);
  };

  render: FC = () => {
    const {canManageLinks, portsSpeeds, rackStore, ports: {free: freePorts}, newLinkRestriction,
      multipleLinks} = this.rackEditorStore;

    return (
      <Popup
        {...this.popupCommonProps()}
        className='linker-popup'
        open={!multipleLinks && canManageLinks.result && (!!rackStore.openedLinksGroupId || rackStore.hasDraftLinks)}
      >
        <Linker
          portsSpeeds={portsSpeeds}
          freePorts={freePorts}
          newLinkRestriction={newLinkRestriction}
        />
      </Popup>
    );
  };
}

export {ManageLinks};
